export default __webpack_public_path__ + "static/media/Helm of the Wailing.81d5e9ab.jpg";